import React from 'react';
import logoiii from '../assets/logoiii.png'
import AvatarBot from './AvatarBot';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer className="bg-black text-white p-6 mt-8">
            <div className="container mx-auto">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-8">

                    <div className="flex flex-col items-center md:items-start">
                      <AvatarBot />
                        {/* <img src={logoiii} alt="Logo de EPICMOVIE" className="w-16 h-16 mb-2" />
                        <h2 className="text-xl font-bold font-montserrat">EPICMOVIE</h2> 
                        <p className="text-sm text-gray-400">Tu plataforma favorita</p>*/}
                    </div>


                    <div>
                        <h3 className="text-lg font-bold mb-4 font-montserrat">Sobre Nosotros</h3>
                        <p className="text-sm">
                            Somos  una plataforma de streaming enfocada en contenido geek, dirigida a una audiencia apasionada por películas, series, cómics
                            y anime. Nuestra misión es ofrecer entretenimiento de
                            calidad con una experiencia visual cómoda y
                            atractiva.
                        </p>
                    </div>


                    <div>
                        <h3 className="text-lg font-bold mb-4 font-montserrat">Enlaces Rápidos</h3>
                        <ul className="text-sm">
                            <li><a href="#" className="hover:text-gray-400">Inicio</a></li>
                            <li><a href="#" className="hover:text-gray-400">Películas</a></li>
                            <li><a href="#" className="hover:text-gray-400">Series</a></li>
                            <li><a href="#" className="hover:text-gray-400">Contacto</a></li>
                        </ul>
                    </div>

                    <div>
                        <h3 className="text-lg font-bold mb-4 font-montserrat">Feedback</h3>
                        <ul className="text-sm">
                            <li>
                                <Link 
                                    to="/feedback" 
                                    className="hover:text-yellow-400 transition-colors duration-300 flex items-center"
                                >
                                    <svg className="w-4 h-4 mr-2 text-yellow-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                        <path fillRule="evenodd" d="M18 5v8a2 2 0 01-2 2h-5l-5 4v-4H4a2 2 0 01-2-2V5a2 2 0 012-2h12a2 2 0 012 2zM7 8H5v2h2V8zm2 0h2v2H9V8zm6 0h-2v2h2V8z" clipRule="evenodd" />
                                    </svg>
                                    Dejar Sugerencia
                                </Link>
                            </li>
                            <li className="mt-2">
                                <p className="text-sm text-gray-400">¡Tu opinión nos importa!</p>
                            </li>
                        </ul>
                    </div>
                </div>


                <div className="border-t border-gray-700 mt-8 pt-8 text-center">
                    <p className="text-sm">
                        &copy; {new Date().getFullYear()} EPICMOVIE. Todos los derechos reservados.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;